import { createContext } from 'react';

export const CopyContactsContext = createContext(null);
